<template>
	<div
		id="steps-container"
		class="w-full flex items-center justify-center"
		:style="{
			'--steps-padding-x': customStyle.paddingX,
			'--steps-font-size': customStyle.fontSize,
		}"
	>
		<ul
			id="steps-list"
			class="flex"
		>
			<li
				v-for="(step, index) in stepsMap"
				:key="index"
				class="flex items-center"
				@click="SelectStep(step, index)"
			>
				<div
					v-if="step.key !== 'pre'"
					class="step-wrapper"
					:class="{
						active: step.isValid,
						selected: currentStep === index,
					}"
				>
					<div class="step-container">
						<span class="step-number">{{ step.number }}</span>
						<p class="step-label">
							{{ step.label }}
						</p>
					</div>
					<div
						v-if="index < stepsMap.length - 1"
						class="separator"
					>
						<i class="far fa-chevron-right mx-2 font-20"></i>
					</div>
				</div>
			</li>
		</ul>
	</div>
</template>

<script>
	export default {
		name: 'Steps',
		props: {
			stepsMap: {
				type: Array,
				default: () => [],
			},
			currentStep: {
				type: Number,
				default: null,
			},
			sidebarState: {
				type: Boolean,
				default: false,
			},
			customStyle: {
				type: Object,
				default: () => ({
					paddingX: '1rem',
					fontSize: '1rem',
				}),
				required: false,
			},
		},
		data() {
			return {}
		},
		computed: {
			filteredSteps() {
				return this.stepsMap.filter(step => step.key !== 'pre')
			},
		},
		methods: {
			SelectStep(step, index) {
				if (!step.isValid) return

				this.$emit('select-step', index)
			},
		},
		mounted() {},
	}
</script>

<style lang="scss" scoped>
	#steps-container {
		--steps-padding-x: 1rem;
		--steps-font-size: 1rem;

		#steps-list {
			li {
				.step-wrapper {
					display: flex;
					align-items: center;

					.step-container {
						display: flex;
						align-items: center;
						justify-content: center;
						padding: 0.5rem var(--steps-padding-x);
						gap: 0.5rem;
						cursor: default;
						font-size: var(--steps-font-size);

						.step-number {
							width: 1.8em;
							height: 1.8em;
							border-radius: 50%;
							background-color: var(--disabledBackgroundColor);
							color: var(--disabledColor);
							display: flex;
							align-items: center;
							justify-content: center;
							font-size: 1.2em;
							font-weight: 700;
						}

						.step-label {
							margin-bottom: 0;
							font-size: 1em;
							font-weight: 700;
							text-transform: uppercase;
							color: var(--disabledColor);
						}
					}

					.separator {
						i {
							color: var(--newPrimaryBackgroundColor);
						}
					}

					&.active {
						.step-container {
							cursor: pointer;

							.step-number {
								background-color: var(
									--newPrimaryBackgroundColor
								);
								color: var(--newPrimaryFocusBackgroundColor);
							}
							.step-label {
								color: var(--newPrimaryBackgroundColor);
							}
						}

						&:hover {
							.step-container {
								.step-number {
									opacity: 1;
									background-color: var(
										--newPrimaryHoverBackgroundColor
									);
									color: var(--newPrimaryHoverColor);
								}

								.step-label {
									color: var(
										--newPrimaryHoverBackgroundColor
									);
								}
							}
						}
					}

					&.selected {
						.step-container {
							cursor: pointer;

							.step-number,
							.step-label {
								font-size: 1.3em;
								font-weight: 700;
								color: var(--fontColor);
							}

							.step-number {
								background-color: var(
									--newPrimaryFocusBackgroundColor
								);
								color: var(--newPrimaryFocusColor);
							}
						}
					}
				}
			}
		}
	}
</style>
